import { mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const Icons = styled.div`
  visibility: hidden;
  opacity: 0;
  // Take 0.1 sec to appear, disappear immediately
  transition:
    visibility 0.1s,
    opacity 0.1s;

  margin-left: 0.5rem;
  display: flex;
  gap: 0.25rem;
`

export const IconWrapper = styled.div`
  padding: 0.25rem;
  display: flex;
  align-items: center;

  ${mixin.clickable};
`

export const StyledRow = styled.div`
  display: flex;

  :hover {
    ${Icons} {
      visibility: visible;
      opacity: 1;
    }
  }
`
